export default __webpack_public_path__ + "static/media/no-right-cark.4b505bf7.svg";